<template>
  <div>
    <div class="choose">
      <van-cell-group>
        <!-- 学年 -->
        <van-field label="学年"
                   @click="isYearShow=true"
                   placeholder="请选择学年"
                   readonly
                   v-model='selectYear' />
        <!-- 学期 -->
        <van-field label="学期"
                   @click="isSessionShow=true"
                   placeholder="请选择学期"
                   readonly
                   v-model='selectSession' />
      </van-cell-group>
      <van-action-sheet v-model="isYearShow"
                        :actions="yearData"
                        @select="yearSelectFun"
                        cancel-text="取消"
                        close-on-click-action />
      <van-action-sheet v-model="isSessionShow"
                        :actions="sessionData"
                        @select="sessionSelectFun"
                        cancel-text="取消"
                        close-on-click-action />
    </div>
    <van-pull-refresh v-if="total > 0"
                      v-model="isLoading"
                      :immediate-check="false"
                      @refresh="onRefresh">
      <van-list v-model="isRefresh"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad">
        <!--@load="onLoad" 暂无数据控制下首次进页面不会请求接口造成报错，这里加onload在上拉刷新使用 -->
        <div class="list-con">
          <div v-for="item in list"
               v-bind:key="item.EvaTeacherTaskID"
               class="list">
            <div class="title">{{item.EvaTeacherTaskName}}</div>
            <div class="center">{{item.SchoolDistrictName}}&nbsp;{{item.AcademicYearName}}&nbsp;{{item.AcademicSessionName}}</div>
            <div class="status van-hairline--top">{{item.IsPublished?'已发布':'未发布'}}</div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <no-data v-else
             :needBg="true"
             class="footer"></no-data>
  </div>
</template>
<script>
import NoData from '@/components/noData/Index'
export default {
  name: 'Setup',
  components: {
    NoData
  },
  data () {
    return {
      isLoading: false,//下拉刷新状态
      pageIndex: 1,
      pageSize: 15,
      isRefresh: false,// 是否加载中
      finished: false,// 加载是否完成
      list: [],
      total: 0,

      //学年
      isYearShow: false,
      selectYear: "",
      selectYearId: 0,
      yearData: [],
      //学期
      isSessionShow: false,
      selectSession: "",
      selectSessionId: 0,
      sessionData: []
    }
  },
  created () {
    this.getYear();
  },
  mounted () {
  },
  methods: {
    //获取学年
    async getYear () {
      this.xy.loading();
      let res = await this.xyapi.get(`${this.xyMApi}/xy/comm/YearList`);
      this.xy.unloading();
      if (res.success) {
        if (res.data.length > 0) {
          res.data.map(item => {
            if (item.IsCurrent) {
              this.selectYearId = item.ID;
              this.selectYear = item.Name;
              this.getSession(item.ID);
            }
            this.yearData.push({
              id: item.ID,
              name: item.Name
            });
          });
        }
      }
    },
    //获取学期
    async getSession (id) {
      this.xy.loading();
      let res = await this.xyapi.get(`${this.xyMApi}/xy/comm/SessionList`, {
        yearID: id
      });
      this.xy.unloading();
      if (res.success) {
        this.selectSession = "";
        this.selectSessionId = 0;
        this.sessionData = [];
        res.data.map(item => {
          if (item.IsCurrent) {
            this.selectSessionId = item.AcademicSessionID;
            this.selectSession = item.AcademicSessionName;
            this.onLoad();
          }
          this.sessionData.push({
            id: item.AcademicSessionID,
            name: item.AcademicSessionName
          });
        });
      }
    },
    //选中学年
    yearSelectFun (e) {
      this.selectYear = e.name;
      this.selectYearId = e.id;
      //学期重置
      this.getSession(e.id);
    },
    // 选中学期
    sessionSelectFun (e) {
      this.selectSession = e.name;
      this.selectSessionId = e.id;
      this.onRefresh();
    },
    //list
    async onLoad () {
      this.xy.loading();
      let res = await this.xyapi.get(`${this.$store.state.apiPath}/api/TeacherTask/GetPage`, {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        yearID: this.selectYearId,
        sessionID: this.selectSessionId
      })
      this.xy.unloading();
      if (res.success) {
        this.total = res.data.totalRecords;
        let _list = res.data.data;
        this.list = [...this.list, ..._list];
        this.pageIndex++;
        this.finished = (this.list.length >= res.data.totalRecords) ? true : false
      } else {
        this.$toast.fail(res.msg);
      }
      // 加载状态结束
      this.isRefresh = false;
    },
    onRefresh () {
      setTimeout(() => {
        this.list = [];
        this.pageIndex = 1;
        this.isLoading = false;
        this.onLoad();
      }, 500);
    },
  }
}
</script>
<style lang="less" scoped>
.van-cell-group {
  display: flex !important;
  /deep/ .van-field__label {
    width: auto !important;
    margin-right: 20px !important;
    span {
      font-size: 28px !important;
    }
  }
  /deep/ .van-field__body {
    input {
      font-size: 28px;
    }
  }
}
.list-con {
  padding: 25px;
  .list {
    margin-bottom: 20px;
    background: #fff;
    box-shadow: 0px 4px 12px 0px rgba(211, 211, 211, 0.5);
    border-radius: 8px;
    padding: 25px;
    .title {
      font-size: 32px;
    }
    .center {
      font-size: 24px;
      color: #666;
      margin: 30px 0;
    }
    .status {
      font-size: 24px;
      margin-top: 15px;
      padding: 20px 0 0px;
      text-align: right;
    }
  }
}
</style>